import Cropper from "@/lib/components/Cropper";
import {CropResponse, SetThumbnailRequest, ThumbnailSize, UploadResponse} from "@/lib/types";
import {fetchBackendNoContent} from "@/lib/backend";
import ErrorPage from "@/lib/components/ErrorPage";
import SpinnerPage from "@/lib/components/SpinnerPage";
import {useSession} from "@/lib/auth/auth";
import {BASE_URL} from "@/lib/constants";
import {useRouter} from "expo-router";
import {useAccount} from "@/lib/components/AccountProvider";

export default function ProfileCropper() {
    const {session} = useSession();
    const router = useRouter();
    const {account, accountError, accountLoading, refreshAccount} = useAccount();

    if (accountError) {
        return <ErrorPage error={accountError}/>
    } else if (accountLoading || !account) {
        return <SpinnerPage/>;
    }

    function onCrop(crop: CropResponse) {
        const payload: SetThumbnailRequest = {
            thumbnail_id: crop.thumbnail_id,
        };
        fetchBackendNoContent("/account", "PATCH", session, payload).then(async () => {
            await refreshAccount();
            router.dismiss();
        }).catch((err) => {
            console.error("set thumbnail", err);
        });
    }

    function imageSource(): UploadResponse | undefined {
        if (account && account.avatar_original_url && account.avatar_id) {
            return {
                image_url: BASE_URL + account.avatar_original_url,
                picture_id: account.avatar_id,
            }
        }
    }

    return (
        <Cropper
            source={imageSource()}
            sizeType={ThumbnailSize.AVATAR}
            onCrop={onCrop}
        />
    );
}